import React from "react";
//import ReactDOM from "react-dom";
import Map from "./Map.jsx";
import {browserHistory} from "react-router";
import ObjectList from "./ObjectList";
import MapObjectOverlay from "./MapObjectOverlay";
import MapWithSunstudy from "./MapWithSunstudy";
import MapObjectSummary from './MapObjectSummary'; // Added by Russlan 2019-02-22

export default class ObjectMap extends React.Component {
    constructor () {
        super();
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        this.state = {
            map: null,
            visibleRooms: [],
            showAll: false,
            iOS: iOS
        };

        this.onObjectClick = this.onObjectClick.bind(this);
        this.onAreaClick = this.onAreaClick.bind(this);
        this.onMapResize = this.onMapResize.bind(this);
        this.onAreaMouseEnter = this.onAreaMouseEnter.bind(this);
        this.onAreaMouseMove = this.onAreaMouseMove.bind(this);
        this.onAreaMouseLeave = this.onAreaMouseLeave.bind(this);
        this.onObjectMouseEnter = this.onObjectMouseEnter.bind(this);
        this.onObjectMouseLeave = this.onObjectMouseLeave.bind(this);
        this.onRoomFilterChange = this.onRoomFilterChange.bind(this);
        this.onOverviewAreaClick = this.onOverviewAreaClick.bind(this);
        this.onMapResizeReal = this.onMapResizeReal.bind(this);
        this.toggleShowAll = this.toggleShowAll.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount () {
        this.loadMap();
    }

    componentDidUpdate (prevProps) {
        let oldId = prevProps.params.id;
        let newId = this.props.params.id;
        if (newId !== oldId) {
            this.loadMap();
        }
    }

    loadMap () {
        const map = this.props.data.object_maps.data.find(m => {
            return m.id === parseInt(this.props.params.id, 10);
        });

        if (!map) {

        }

        if (this.props.data.objects) {
            let visibleObjects = [];
            map.regions.data.map(region => {
                const object = this.props.data.objects.data.find(obj => {
                    return obj.id === region.entity_id;
                });

                const exists = visibleObjects.find(obj => obj.id === region.entity_id);

                if (!object) {
                    console.log(`object with id ${region.entity_id} not found`)
                }

                if (!exists) {
                    region.object = object;
                    visibleObjects.push(object);
                    return region;
                }
                else return null;
            });

            this.setState({
                visibleObjects: visibleObjects
            });
        }

        const sunstudy = map.sunstudy;

        const availableRooms = this.props.data.objects.data.map(obj => {
            return obj.data['rooms'];
        }).reduce((p, c) => {
            if (p.indexOf(c) < 0) p.push(c);
            return p;
        }, []).sort();

        this.setState({
            map: map,
            sunstudy: sunstudy,
            visibleRooms: availableRooms
        });
    }

    onAreaClick (area, e) {
        const object = this.props.data.objects.data.find(obj => {
            return obj.id === area.entity_id;
        });

        if (!object) {
            return false;
        }

        // Amended by Russlan 2019-02-22 (old code)
        // let url = `${this.props.location.pathname}/object/${object.number}`;
        // browserHistory.push(url);

        // Amended by Russlan 2019-02-22 (new code)       
        var objectSummaryElement = document.getElementById('object-summary');
            
        var smallScreen = false;

        if (objectSummaryElement) {
            //var displayStyle = window.getComputedStyle(objectSummaryElement).getComputedStyle("display");
            var displayStyle = window.getComputedStyle(objectSummaryElement)['display'];
            smallScreen = (displayStyle === 'block');
        }

        //if ((!smallScreen) || ((this.state.lastClickedObject != null) && (this.state.lastClickedObject.guid === object.guid)))
        if ((!smallScreen) || ((this.state.lastClickedObject) && (this.state.lastClickedObject.guid === object.guid)))
        {
            let url = `${this.props.location.pathname}/object/${object.number}`;
            browserHistory.push(url);    
        }
        else this.setState({lastClickedObject: object});

        return true;        
    }

    onAreaMouseEnter (area, e) {
        /*this.setState({
            hoverObject: area.object
        });*/
    }

    onAreaMouseMove (area, e) {
        //console.log('omap fin');
        this.setState({
            mousePosition: {
                x: e.clientX + 10,
                y: e.clientY + 10
            },
            hoverObject: area.object,
            //lastClickedObject: area.object
        });   

        // Add click behaviour to iOS brouser, as it is not likely to receive
        if (this.state.iOS) this.onAreaClick(area);
    }

    onAreaMouseLeave (area, e) {
        // if (this.state.iOS)
        // {
        // }
        // else {
        //     this.setState({
        //         hoverObject: null,
        //         mousePosition: null
        //     });    
        // }
        if (!this.state.iOS)
        {
            this.setState({
                hoverObject: null,
                mousePosition: null
            });        
        }

    }

    onObjectMouseEnter (object) {
        //this.setState({ hoverObject: object });

        // Add click effect to iOS brouser, as it is not likely to receive
        if (this.state.iOS) this.setState({ hoverObject: object, lastClickedObject: object });
        else this.setState({ hoverObject: object });
    }

    onObjectMouseLeave (object) {
    }

    onObjectClick (object) {
        // Amended by Russlan 2019-02-24 (old code)
        // let url = `${this.props.location.pathname}/object/${object.number}`;
        // browserHistory.push(url);

        // Amended by Russlan 2019-02-24 (new code)
        var objectSummaryElement = document.getElementById('object-summary');
         
        var smallScreen = false;

        if (objectSummaryElement) {
            //var displayStyle = window.getComputedStyle(objectSummaryElement).getComputedStyle("display");
            var displayStyle = window.getComputedStyle(objectSummaryElement)['display'];
            smallScreen = (displayStyle === 'block');
        }

        //if ((!smallScreen) || ((this.state.lastClickedObject != null) && (this.state.lastClickedObject.guid === object.guid)))
        if ((!smallScreen) || ((this.state.lastClickedObject) && (this.state.lastClickedObject.guid === object.guid)))
        {            
            //let url = `${this.props.location.pathname}/object/${this.state.lastClickedObject.number}`;
            let url = `${this.props.location.pathname}/object/${object.number}`;
            browserHistory.push(url);    
        }
        else this.setState({lastClickedObject: object, hoverObject: object});

        return true;        
    }

    onMapResize (dimensions) {
        this.setState({
            //mapWidth: dimensions.width,
            mapHeight: dimensions.height,
        });
    }

    toggleShowAll () {
        this.setState({
            showAll: !this.state.showAll
        });
    }

    onMapResizeReal (dimensions) {
        this.setState({
            //mapWidth: dimensions.width,
            mapHeight: dimensions.height,
        });
    }

    goBack () {
        browserHistory.push(`/${this.props.params.client}/${this.props.params.widget}`);
    }

    onRoomFilterChange (rooms) {
        this.setState({
            visibleRooms: rooms
        });
    }

    onOverviewAreaClick (area) {
        browserHistory.push(`/${this.props.params.widget}/map/${area.map_id}`);
    }

    render () {
        if (!this.state.map) {
            return null;
        }

        const idx = this.props.data.object_maps.data.findIndex(m => {
            return m.id === this.state.map.id;
        });

        const nextMap = this.props.data.object_maps.data[idx + 1] ? this.props.data.object_maps.data[idx + 1] : null;
        const previousMap = this.props.data.object_maps.data[idx - 1] ? this.props.data.object_maps.data[idx - 1] : null;

        //const miniMap = this.props.data.overview_maps[0];

        const backButton = !!this.props.data['template_config']['overview'];

        let map;

        if (this.state.sunstudy) {
            map = <MapWithSunstudy map={this.state.map}
                                   showAll={this.state.showAll}
                                   objects={this.props.data.objects}
                                   visibleRooms={this.state.visibleRooms}
                                   sunstudy={this.state.sunstudy}
                                   onResize={this.onMapResize}
                                   onMapResize={this.onMapResizeReal}
                                   onAreaClick={this.onAreaClick}
                                   onBack={this.goBack}
                                   nextMap={nextMap}
                                   previousMap={previousMap}
                                   lastClickedObject={this.state.lastClickedObject} // Added by Russlan 2019-02-22
                                   hoverObject={this.state.hoverObject}
                                   backButton={backButton}
                                   onToggleShowAll={this.toggleShowAll}
                                   onRoomFilterChange={this.onRoomFilterChange}
                                   onAreaMouseEnter={this.onAreaMouseEnter}
                                   onAreaMouseMove={this.onAreaMouseMove}
                                   onAreaMouseLeave={this.onAreaMouseLeave}>

            </MapWithSunstudy>
        } else {
            map = <Map map={this.state.map}
                       showAll={this.state.showAll}
                       objects={this.props.data.objects}
                       visibleRooms={this.state.visibleRooms}
                       onResize={this.onMapResize}
                       onMapResize={this.onMapResizeReal}
                       onAreaClick={this.onAreaClick}
                       nextMap={nextMap}
                       previousMap={previousMap}
                       lastClickedObject={this.state.lastClickedObject} // Added by Russlan 2019-02-22
                       hoverObject={this.state.hoverObject}
                       onRoomFilterChange={this.onRoomFilterChange}
                       onAreaMouseEnter={this.onAreaMouseEnter}
                       onAreaMouseMove={this.onAreaMouseMove}
                       onAreaMouseLeave={this.onAreaMouseLeave}>

                <button type="button" onClick={this.toggleShowAll}
                        className={this.state.showAll ? 'cw-map-toggle-all active' : 'cw-map-toggle-all'}>
                    Visa alla
                </button>

                {backButton ?
                    <button type="button" onClick={this.goBack} className={'cw-map-back'}>
                        Översiktsbild</button> : ''
                }
            </Map>
        }

        return (
            <div>
                <div className="cw-object-map-wrap">
                    <div className="cw-map">
                        {map}
                        {(this.state.hoverObject && this.state.mousePosition) &&
                        <MapObjectOverlay object={this.state.hoverObject} mousePosition={this.state.mousePosition}></MapObjectOverlay>
                        }
                    </div>
                    {/* Added by Russlan 2019-02-22 - begin */}
                    <div className="cw-map-object-summary-wrap">
                    <MapObjectSummary 
                        object={this.state.hoverObject}
                        location={this.props.location}
                        hoverObject={this.state.hoverObject}
                        lastClickedObject={this.state.lastClickedObject}/>
                    </div>
                    <div className="cw-object-list-wrap">
                        <ObjectList objects={this.state.visibleObjects}
                                    width={this.state.mapWidth}
                                    height={this.state.mapHeight}
                                    lastClickedObject={this.state.lastClickedObject} // Added by Russlan 2019-02-22
                                    hoverObject={this.state.hoverObject}
                                    visibleRooms={this.state.visibleRooms}
                                    iOS={this.state.iOS}
                                    onObjectMouseEnter={this.onObjectMouseEnter}
                                    onObjectMouseLeave={this.onObjectMouseLeave}
                                    onObjectClick={this.onObjectClick}/>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ObjectMap.jsx